import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Button from 'portal-modules/common/components/Button'
import { TaxDetails } from 'portal-modules/common/components'
import { RpModal } from 'portal-modules/common/components/modals'
import { requestBulkPaymentsListModal } from 'portal-modules/common/redux/modules/bulkPaymentsListModal'
import { connect } from 'react-redux'
import { Spinner } from 'portal-modules/common/components/loaders'
import getDateForLocale from 'portal-modules/common/utils/get-date-for-locale'

const StyledSection = styled('section')`
  display: flex;
  justify-content: space-between;
  padding: ${({ hasTaxes }) => (hasTaxes ? '4px 0' : '8px 0')};
`

const StyledButton = styled(Button)`
  min-width: 100%;
`

const StyledSubAmountTotal = styled('section')`
  justify-content: space-between;
  display: flex;
  padding: ${({ hasTaxes }) => (hasTaxes ? '4px 0' : '8px 0')};
  font-weight: bold;
  padding-top: 24px;
`

const StyledLoaderDiv = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`

const BulkTransactionDetailsModal = ({
  transactionDetails,
  onClose,
  bulkPaymentsListModal,
  leases,
  isLeaseAndRentWordReplaced,
  ...props
}) => {
  const { date, title, created_by_name, payment_group_id } = transactionDetails

  const [loader, setLoader] = useState(false)
  const leaseReplacedText = isLeaseAndRentWordReplaced
    ? 'Housing Agreement'
    : 'Lease'

  useEffect(() => {
    const { requestBulkPaymentsListModal } = props
    setLoader(true)
    requestBulkPaymentsListModal({
      payment_group_id: payment_group_id,
      callback: () => setLoader(false),
    })
  }, [])

  const loadingKeys = ['payment_details']

  const subTotal = bulkPaymentsListModal.length
    ? bulkPaymentsListModal.reduce(
        (prevAmt, el) => prevAmt + +el.total_amount,
        0,
      )
    : 0
  return (
    <RpModal
      {...props}
      title={title}
      loadingKeys={loadingKeys}
      footerContent={
        <StyledButton appearance='primary' onClick={onClose}>
          {__('Close')}
        </StyledButton>
      }
    >
      {loader ? (
        <StyledLoaderDiv>
          <Spinner />
        </StyledLoaderDiv>
      ) : (
        <div>
          <StyledSection>
            <span>{__('Payment Date')}</span>
            <span>{getDateForLocale(date)}</span>
          </StyledSection>
          <StyledSection>
            <span>{__('Time of Payment')}</span>
            <span>{i18nUtils.datetime(date, 'TIME_SHORT')}</span>
          </StyledSection>
          {created_by_name && (
            <StyledSection>
              <span>{__('Submitted By')}</span>
              <span>{__('{%s,0}', [created_by_name])}</span>
            </StyledSection>
          )}
          {!!bulkPaymentsListModal?.length &&
            bulkPaymentsListModal.map(
              ({ unit_number, total_amount, lease_id }) => (
                <StyledSection key={unit_number}>
                  {unit_number ? (
                    <span>
                      {__('Unit {%s,0} ', [
                        leases[lease_id].unit_number || unit_number,
                      ])}
                    </span>
                  ) : (
                    <span>
                      {__('{%s, 1} #{%s,0} ', [lease_id, leaseReplacedText])}
                    </span>
                  )}
                  <span>{i18nUtils.currency(total_amount)}</span>
                </StyledSection>
              ),
            )}
          <StyledSubAmountTotal>
            <span>{__('Subtotal')}</span>
            <span>{i18nUtils.currency(subTotal)}</span>
          </StyledSubAmountTotal>
        </div>
      )}
    </RpModal>
  )
}

BulkTransactionDetailsModal.propTypes = {
  transactionDetails: PropTypes.object,
  bulkPaymentsListModal: PropTypes.object,
  leases: PropTypes.object,
  onClose: PropTypes.func,
  requestBulkPaymentsListModal: PropTypes.func,
  isLeaseAndRentWordReplaced: PropTypes.bool,
}

export default connect(
  ({
    productPermissions,
    bulkPaymentsListModal,
    leases,
    propertyAssociation,
  }) => {
    return {
      hasPermissions: Object.keys(productPermissions).length > 1,
      bulkPaymentsListModal: Object.keys(bulkPaymentsListModal).length
        ? bulkPaymentsListModal
        : [],
      leases,
      isLeaseAndRentWordReplaced:
        productPermissions?.replace_lease_and_rent ||
        propertyAssociation?.resident_portal?.replace_lease_and_rent ||
        false,
    }
  },
  { requestBulkPaymentsListModal },
)(BulkTransactionDetailsModal)
